import { render } from "./SonicuButton.vue?vue&type=template&id=1d16bbb4"
import script from "./SonicuButton.vue?vue&type=script&lang=js"
export * from "./SonicuButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__